import TilePropertiesContainer from './Izenda.TilePropertiesContainer';

const SCHEMA_DEF = {
    title: '',
    component: 'TilePropertiesContainer',
    props: {      
      reportDesignerModel: 'reportDesignerModel',
      fieldStore: 'fieldStore'
    },
    fields: {}
};

const WIDGETS = {
    TilePropertiesContainer
};

export default function (editorComp, reportDesignerModel, fieldStore) {
    return {
        // define data to render UI
        definedSchema: SCHEMA_DEF,
        // list of widgets which are used to render UI
        widgets: WIDGETS,
        // data to binding to fields
        source: {},
        // properties for different fields
        mappingProps: {
            reportDesignerModel: reportDesignerModel,
            fieldStore: fieldStore
        },
        // defined-function which fields need to execute to get its data
        mappingSource: {},
        // mapping data from editor to report-designer- model
        onChangeValue: function (schemaData) {}
    }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/TilePropertiesContainer/izenda.TilePropertiesContainerSchema.js